/* tslint:disable */
/* eslint-disable */
/**
 * CVAT REST API
 * REST API for Computer Vision Annotation Tool (CVAT)
 *
 * The version of the OpenAPI document: 2.31.0
 * Contact: support@cvat.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * * `lexicographical` - LEXICOGRAPHICAL * `natural` - NATURAL * `predefined` - PREDEFINED * `random` - RANDOM
 * @export
 * @enum {string}
 */

export const SortingMethod = {
    Lexicographical: 'lexicographical',
    Natural: 'natural',
    Predefined: 'predefined',
    Random: 'random'
} as const;

export type SortingMethod = typeof SortingMethod[keyof typeof SortingMethod];



